import React from "react";
import EventPill from "./EventPill";
import { formatDate } from "../../utils/dateUtils";

const CalendarDayCell = ({
  dayObj,
  index,
  selectedDates,
  vacationDates,
  dateRangeStart,
  dateRangeEnd,
  dateRangeMode,
  getEventsForDate,
  styles,
  screenSize,
  language,
  t,
  onDateClick,
  onEventClick,
  onShowMoreEvents,
}) => {
  const date = dayObj.date ? new Date(dayObj.date) : null;

  if (!date) {
    return <div key={index} />;
  }

  const dateString = formatDate(date);
  const isSelected = selectedDates.has(dateString);
  const isToday = date.toDateString() === new Date().toDateString();
  const isVacation = vacationDates.has(dateString);
  const dayEvents = getEventsForDate(date);

  const isInRange =
    dateRangeStart &&
    dateRangeEnd &&
    date >= dateRangeStart &&
    date <= dateRangeEnd;

  const hasEvents = dayEvents.length > 0;

  return (
    <div
      style={styles.calendarDay(
        dayObj,
        isSelected,
        isToday,
        isVacation,
        isInRange,
        getEventsForDate,
        dateRangeMode
      )}
      onClick={() => onDateClick(date)}
    >
      <div
        style={styles.calendarDayNumber(isSelected, isToday, isVacation, hasEvents)}
      >
        {date.getDate()}
      </div>

      {dayEvents.slice(0, screenSize.isMobile ? 2 : 3).map((event) => (
        <EventPill
          key={event.id}
          event={event}
          screenSize={screenSize}
          language={language}
          t={t}
          onEventClick={onEventClick}
        />
      ))}

      {dayEvents.length > (screenSize.isMobile ? 2 : 3) && (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            onShowMoreEvents?.(date, dayEvents);
          }}
          style={{
            fontSize: screenSize.isMobile ? "9px" : "10px",
            color: "#888",
            textAlign: "center",
            marginTop: "2px",
            background: "none",
            border: "none",
            padding: 0,
            width: "100%",
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          +{dayEvents.length - (screenSize.isMobile ? 2 : 3)} {t.more}
        </button>
      )}
    </div>
  );
};

export default CalendarDayCell;
